import { render } from "./ReservationAdd.vue?vue&type=template&id=b3faf568&scoped=true"
import script from "./ReservationAdd.vue?vue&type=script&lang=js"
export * from "./ReservationAdd.vue?vue&type=script&lang=js"

import "./ReservationAdd.vue?vue&type=style&index=0&id=b3faf568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3faf568"]])

export default __exports__